/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmRegistration
 */
export interface ConfirmRegistration {
    /**
     * 
     * @type {number}
     * @memberof ConfirmRegistration
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof ConfirmRegistration
     */
    otp: string;
}

/**
 * Check if a given object implements the ConfirmRegistration interface.
 */
export function instanceOfConfirmRegistration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "otp" in value;

    return isInstance;
}

export function ConfirmRegistrationFromJSON(json: any): ConfirmRegistration {
    return ConfirmRegistrationFromJSONTyped(json, false);
}

export function ConfirmRegistrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmRegistration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'otp': json['otp'],
    };
}

export function ConfirmRegistrationToJSON(value?: ConfirmRegistration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'otp': value.otp,
    };
}

